function PopoverOverlayCtrl(popoverService) {
  const ctrl = this;
  ctrl.overlayHide = function () {
    popoverService.getPopoverScope(ctrl.popoverId).then(popoverScope => {
      popoverScope.deactive();
      ctrl.popoverId = null;
      ctrl.isVisibleOverlay = false;
    });
  };
  popoverService.addPopoverOverlay(ctrl);
}
PopoverOverlayCtrl.$inject = ["popoverService"];
export default PopoverOverlayCtrl;